module.exports = __webpack_public_path__ + "static/media/02-10.46929263.png";